<span
    class="browse-button"
    [attr.data-uiid]="dataUiid + 'browse-button'"
    (click)="openFileSelect()"
    >{{ text ?? ('effBrowseFilesButton.browse' | t) }}</span
>

<input
    type="file"
    id="fileUpload"
    [accept]="allowedFileExtensions"
    [multiple]="true"
    [hidden]="true"
    [attr.data-uiid]="dataUiid + '-file-input'"
    (change)="updateFiles()"
    #fileInput
/>
